<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="display-1 mt-4 primary--text">Login</h2>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs2></v-flex>
      <v-flex xs12 md4 class="extra-pad">
        <v-card style="height:100%">
          <v-card-title>
            <h3 class="primary--text" style="width:100%"
              >Sign in with Google</h3
            >
          </v-card-title>
          <v-card-text>
            <GoogleSignin alwaysShowButton> </GoogleSignin>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 class="extra-pad">
        <v-card>
          <v-card-title>
            <h3 class="primary--text" style="width:100%"
              >Sign in with Username</h3
            >
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="username" label="Username"></v-text-field>
            <v-text-field
              v-model="password"
              label="Password"
              type="password"
            ></v-text-field>
            <v-btn
              color="secondary"
              @click="logInUnPw({ email: username, password: password })"
              :disabled="!(username && password)"
              >Sign in</v-btn
            >
            <br />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs2></v-flex>
      <v-flex xs12>
        <span>Don't have an account?</span>
        <v-btn color="primary" @click="_register">Register</v-btn>
        <span>Forgot your password?</span>
        <v-btn color="primary" @click="dialog2 = true">Reset Password</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="850px">
      <v-card>
        <v-card-text>
          <span v-for="(e, idx) in authErrors" :key="idx" class="error--text"
            >{{ e }}<br
          /></span>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="850px">
      <v-card>
        <v-card-text>
          <v-text-field
            label="Enter the email you registered with"
            v-model="email"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="_resetPassword"
            >Send link to reset password</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog3" max-width="850px">
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              {{ msg }}
              <template v-for="(e, idx) in errors">
                <div :key="idx">
                  {{ e }} <br />
                  <br />
                </div>
              </template>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-footer absolute style="height:80px;">
      <v-layout row wrap justify-center>
        <img src="../../assets/identity-logo.png" height="64px" />
        <v-flex xs12 style="height:100%; vertical-align:middle;">
          This app uses the Wyoming Identity System for Authentication
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GoogleSignin from '@components/login/google-signin'
export default {
  page: {
    title: 'Login',
  },
  data() {
    return {
      username: '',
      password: '',
      dialog: false,
      dialog2: false,
      dialog3: false,
      msg: '',
      errors: [],
      email: '',
    }
  },
  methods: {
    _register() {
      this.$router.push({ path: '/Register', name: 'Register' })
    },
    ...mapActions('auth', ['logInUnPw']),
    _resetPassword() {
      this.dialog2 = false
      this.errors = []
      const self = this
      axios
        .get(`/Register/PasswordResetToken/${this.email}`)
        .then((response) => {
          this.msg = response.data
          this.dialog3 = true
        })
        .catch((e) => {
          this.msg = `There was an error sending reset password link to ${this.email} -`
          let err = e.response.data
          if (JSON.stringify(err).substring(0, 1) != '{') {
            self.errors.push(err)
          } else {
            Object.keys(err).forEach((val) => {
              self.errors.push(err[val][0])
            })
          }
          this.dialog3 = true
        })
    },
  },
  computed: {
    ...mapGetters('auth', ['authErrors', 'isLoggedIn', 'isAdmin']),
  },
  watch: {
    authErrors: {
      handler(val) {
        this.username = ''
        this.password = ''
        if (val && val.length > 0) this.dialog = true
      },
      deep: true,
    },
    isLoggedIn(val) {
      if (val) {
        if (this.isAdmin) {
          this.$router.push({ path: '/AdminPage' })
        } else {
          this.$router.push({ path: '/UserPage' })
        }
      }
    },
  },
  components: {
    GoogleSignin,
  },
}
</script>

<style></style>
